import { getMobileOperatingSystem } from '@/utils/getMobileOS';

export const salesStepLabels = ['personal', 'tariffs', 'activation'];

export const swapStepSales = ['personal', 'activation'];

export const cardDatas = (t) => ({
  title: t('esim:cards.title'),
  cards: [
    {
      id: 0,
      content: [
        { text: 'MilliÖn', url: 'https://million.az/attributes/Bakcell' },
        {
          text: 'eMANAT',
          url: 'https://mpay.az/payments/p/9f8418ca-da26-43a6-abe9-409c42df6b72',
        },
        {
          text: 'ExpressPay',
          url: 'https://expresspay.az/login',
        },
      ],
      icon: '/assets/marker.png',
      title: t('esim:cards.terminal'),
    },
    {
      id: 1,
      content: [
        {
          text: 'hesab.az',
          url: 'https://hesab.az/unregistered/#/direct-pay/mobile/bakcell/parameters',
        },
        {
          text: 'azericard.az',
          url: 'https://bakcell.3dsecure.az/',
        },
      ],
      icon: '/assets/marker.png',
      title: t('esim:cards.platform'),
    },
    {
      id: 2,
      content: [
        {
          text: 'BirBank',
          url:
            typeof window !== 'undefined' && window.innerWidth > 600
              ? 'https://payments.kapitalbank.az/attributes/information/1102'
              : getMobileOperatingSystem(),
        },
      ],
      icon: '/assets/marker.png',
      title: t('esim:cards.mobileApp'),
    },
  ],
});
